import { useEffect, useRef } from 'react';

export const useOnKeyChange = (key: string, onChange: () => void) => {
  const lastKeyRef = useRef(key);

  useEffect(() => {
    if (lastKeyRef.current === key) {
      return;
    }

    lastKeyRef.current = key;
    onChange();
  }, [key, onChange]);
};
